import { Dialog, styled } from "@mui/material";
import React from "react";
import {
  PulsePopupContainer,
  PulsePopupContainerSize,
} from "@pulselabs-ai/shared-fe-ui";
import "./CustomDialog.scss";

interface CustomDialogProps {
  isOpen: boolean;
  containerSize?: PulsePopupContainerSize;
  onClose: () => void;
  showCloseIcon?: boolean;
  children?: React.ReactNode;
  paperStyles?: React.CSSProperties;
  isBackgroundClose?: boolean;
  roundedCorners?: boolean;
}

const MaterialDialog = styled(Dialog)();

const CustomDialog: React.FC<CustomDialogProps> = ({
  isOpen,
  onClose,
  showCloseIcon = true,
  children,
  paperStyles,
  isBackgroundClose = true,
  containerSize,
  roundedCorners = false,
}) => {
  return (
    <MaterialDialog
      onClose={(_, reason) => {
        if (isBackgroundClose || reason !== "backdropClick") {
          onClose();
        }
      }}
      aria-labelledby={"dialog"}
      aria-modal
      open={isOpen}
      className={`custom-dialog ${roundedCorners ? "rounded" : ""}`}
      disableScrollLock={true}
      disablePortal={false}
      keepMounted={true}
      PaperProps={{
        style: {
          ...paperStyles,
        },
      }}
    >
      <PulsePopupContainer
        size={containerSize}
        onClose={showCloseIcon ? onClose : undefined}
      >
        {children}
      </PulsePopupContainer>
    </MaterialDialog>
  );
};

export default CustomDialog;
